import React from 'react'
import ReactQuill from 'react-quill';
import './quillSnow.css';
import { Context } from '../../App';
import { useState, useEffect, useContext, useRef, useReducer } from "react";

const modules = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    // ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

function DocsEditor({ handleNotesKeyDown }) {

  const { fileIdContext, quillDocsContext } = useContext(Context);


  const [text, setText] = quillDocsContext;

  return (

    <ReactQuill value={text} onChange={(e) => {setText(e)}} style={{ }} placeholder={"Type Here..."} modules={modules} theme="snow"
    className='h-full w-full //pt-[47px] '
    onKeyDown={handleNotesKeyDown}
    />
  )
}

export default DocsEditor